// extracted by mini-css-extract-plugin
export default {"fullScreenButton":"RHsOUF1Y3p8Ilzh_LNbV"};